import React from 'react';
import { useData } from '../../contexts';
import { MdOutlineFileDownload } from 'react-icons/md';
import { Tooltip, TooltipTrigger, TooltipContent } from '../Tooltip/Tooltip';
import html2canvas from 'html2canvas';

const handleClickDownloadPNG = (id: any, fileName: any) => {
  const table: any = document.getElementById(id);

  html2canvas(table).then(function (canvas) {
    const link = document.createElement('a');
    link.download = fileName + '.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  });
};

export const DownloadButton = (props: any) => {
  const { id, name } = props;
  const { interfaceColor } = useData();

  return (
    <div
      className={'vl-typography'}
      style={{
        float: 'right',
        // marginLeft: 'auto',
        marginRight: '8px',
        cursor: 'pointer',
        paddingRight: '8px',
        paddingLeft: '0',
        textDecoration: 'underline',
        color: interfaceColor,
        borderRadius: 12,
        position: 'relative',
        top: '18px',
      }}
    >
      <Tooltip>
        <TooltipTrigger
          onClick={() => handleClickDownloadPNG(id, name)}
          style={{
            cursor: 'pointer',
            textAlign: 'right',
            paddingTop: '4px',
            // color: interfaceColor,
          }}
        >
          <MdOutlineFileDownload />
        </TooltipTrigger>
        <TooltipContent className="Tooltip">
          Klik om de data te downloaden als png-bestand
        </TooltipContent>
      </Tooltip>
    </div>
  );
};
